/**
 *  @class
 *  @function CountdownTimer
 */
if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      this.io = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.init();
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: `0px 0px 500px 0px` });

      this.io.observe(this);
    }
    init() {
      // One loop only, even if the observer reports more than one intersecting entry
      if (this.started) return;
      this.started = true;

      const timezone = this.dataset.timezone,
        date = this.dataset.date.split('-'),
        day = parseInt(date[0]),
        month = parseInt(date[1]),
        year = parseInt(date[2]);

      let time = this.dataset.time,
        tarhour = 0,
        tarmin = 0;

      if (time) {
        [tarhour, tarmin] = time.split(':').map(Number);
      }

      // Set the date we're counting down to
      let date_string = month + '/' + day + '/' + year + ' ' + tarhour + ':' + tarmin + ' GMT' + timezone;
      // Time without timezone
      this.countDownDate = new Date(year, month - 1, day, tarhour, tarmin, 0, 0).getTime();

      // Time with timezone
      this.countDownDate = new Date(date_string).getTime();

      requestAnimationFrame(this.updateTime);
    }
    convertDateForIos(date) {
      var arr = date.split(/[- :]/);
      date = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
      return date;
    }
    connectedCallback() {

      const daysEl = this.querySelector('.days .countdown-timer--column--number'),
        hoursEl = this.querySelector('.hours .countdown-timer--column--number'),
        minutesEl = this.querySelector('.minutes .countdown-timer--column--number'),
        secondsEl = this.querySelector('.seconds .countdown-timer--column--number');

      // Wrap each number in a clip container with an initial current span.
      // The clip container gets overflow:hidden; the number element keeps its
      // :before colon pseudo-element outside the clipping context.
      [daysEl, hoursEl, minutesEl, secondsEl].forEach(el => {
        const clip = document.createElement('span');
        clip.className = 'countdown-clip';
        const current = document.createElement('span');
        current.className = 'countdown-num--current';
        current.textContent = el.textContent;
        el.textContent = '';
        clip.appendChild(current);
        el.appendChild(clip);
      });

      // Started by init() once the IntersectionObserver has set countDownDate
      this.updateTime = () => {
        // Get todays date and time
        const now = Date.now();

        // Find the distance between now an the count down date
        const distance = this.countDownDate - now;

        // Expired, or a date that didn't parse: stop the loop and hide the timer
        if (isNaN(distance) || distance <= 0) {
          CountdownTimer.setNumber(daysEl, '00');
          CountdownTimer.setNumber(hoursEl, '00');
          CountdownTimer.setNumber(minutesEl, '00');
          CountdownTimer.setNumber(secondsEl, '00');
          // The theme editor keeps it on screen so it can still be edited
          if (!window.Shopify?.designMode) {
            // A banner's heading and link only read right while the clock runs, so the
            // whole section goes; in the pop-up only the timer does
            const banner = this.closest('.countdown-banner');
            if (banner) {
              (banner.closest('.shopify-section') || banner).style.display = 'none';
            } else {
              this.style.display = 'none';
            }
          }
          return;
        }

        // Time calculations for days, hours, minutes and seconds
        const days = Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds = Math.floor((distance % (1000 * 60)) / 1000);

        requestAnimationFrame(this.updateTime);

        CountdownTimer.setNumber(daysEl, CountdownTimer.addZero(days));
        CountdownTimer.setNumber(hoursEl, CountdownTimer.addZero(hours));
        CountdownTimer.setNumber(minutesEl, CountdownTimer.addZero(minutes));
        CountdownTimer.setNumber(secondsEl, CountdownTimer.addZero(seconds));

      };
    }
    static setNumber(el, newVal) {
      newVal = String(newVal);
      const clip = el.querySelector('.countdown-clip');
      const entering = clip.querySelector('.countdown-num--entering');
      const current = clip.querySelector('.countdown-num--current');
      // Guard: already showing or already animating to this value
      if ((entering || current) && (entering || current).textContent === newVal) return;

      // Cancel any in-flight animations
      const leaving = clip.querySelector('.countdown-num--leaving');
      if (leaving) leaving.remove();
      if (entering) entering.remove();

      // Animate current out
      if (current) {
        current.className = 'countdown-num--leaving';
        current.addEventListener('animationend', () => current.remove(), { once: true });
      }

      // Animate new value in
      const next = document.createElement('span');
      next.className = 'countdown-num--entering';
      next.textContent = newVal;
      clip.appendChild(next);

      next.addEventListener('animationend', () => {
        next.className = 'countdown-num--current';
      }, { once: true });
    }
    static addZero(x) {
      return (x < 10 && x >= 0) ? "0" + x : x;
    }
  }
  customElements.define('countdown-timer', CountdownTimer);
}
